import ExportMailbox from './components/ExportMailbox';
import * as React from 'react';
import { isControlFeatureEnabled } from 'owa-controls-feature-flags';
var ExportMailboxOption = {
    key: 'exportMailbox',
    titleStringKey: 'optionTitle_export_mailbox',
    searchTermsStringKey: 'optionTitle_export_mailbox',
    fullOptionFormSettings: {
        render: function () { return React.createElement(ExportMailbox, null); },
        isDirty: function () { return false; },
        onSave: null,
        onDiscard: null,
        hideSaveDiscard: function () { return true; },
    },
    isHidden: function () { return !isControlFeatureEnabled('fwk-exportMailboxOption'); },
};
export default ExportMailboxOption;
//# sourceMappingURL=ExportMailboxOption.js.map